import { render, staticRenderFns } from "./BlackListClientsTab.vue?vue&type=template&id=6fd72c05"
import script from "./BlackListClientsTab.vue?vue&type=script&lang=js"
export * from "./BlackListClientsTab.vue?vue&type=script&lang=js"
import style0 from "./BlackListClientsTab.vue?vue&type=style&index=0&id=6fd72c05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports